import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { Card, Spin, Icon } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getEvent, cleanEvent } from '../../store/actions/event';
import { event } from '../../store/selectors/event';
import config from './config';

import Buttons from './Buttons';
import EventForm from '../../components/EventForm';

import styles from '../../styles';

const ViewEvent = ({ event, getEvent, cleanEvent, match, history }) => {
  useEffect(() => {
    const { id } = match.params;
    getEvent(id).catch(() => history.push('/404'));
    return cleanEvent;
  }, []);

  useEffect(() => {
    if (event && !event.isReadable) {
      history.push('/403');
    }
  }, [event]);

  const onBackPress = () => history.goBack();

  return (
    <Card
      title="Event details"
      style={styles.formContainer}
      extra={<Icon type="close" onClick={onBackPress} />}
    >
      <Spin spinning={!event}>
        <Formik initialValues={event} enableReinitialize>
          {({ validateForm, values, setFieldValue }) => (
            <EventForm
              operation="read"
              values={values}
              settings={config}
              validateForm={validateForm}
              setValue={setFieldValue}
            >
              <Buttons back={onBackPress} />
            </EventForm>
          )}
        </Formik>
      </Spin>
    </Card>
  );
};

ViewEvent.propTypes = {
  event: PropTypes.shape({
    game: PropTypes.arrayOf(PropTypes.string),
    isReadable: PropTypes.bool,
  }),
  getEvent: PropTypes.func.isRequired,
  cleanEvent: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

ViewEvent.defaultProps = {
  event: null,
};

const mapStateToProps = state => ({
  event: event(state),
});
export default connect(mapStateToProps, { getEvent, cleanEvent })(
  withRouter(ViewEvent),
);
